// Mensagem para o celular cadastrado do usuário (Usuários → ícone de celular). Vai pelo WhatsApp da central,
// assinada com o nome de quem mandou; fica registrada nos avisos do usuário.
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField, Tooltip } from "@material-ui/core";
import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone";

import suporteApi, { mensagemErro } from "./api";
import { usePermissao } from "./permissoes";

const MensagemCelular = ({ usuario }) => {
  const [aberto, setAberto] = useState(false);
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
  const pode = usePermissao("usuarios.avisar");
  if (!pode) return null;
  const enviar = async () => {
    setEnviando(true);
    try {
      await suporteApi.post(`/api/usuarios/${usuario.id}/mensagem`, { texto });
      toast.success(`Mensagem enviada para o celular de ${usuario.name}`);
      setTexto("");
      setAberto(false);
    } catch (e) { toast.error(mensagemErro(e)); }
    setEnviando(false);
  };
  return (
    <>
      <Tooltip title="Mensagem no celular do usuário">
        <IconButton size="small" onClick={() => setAberto(true)}><PhoneIphoneIcon /></IconButton>
      </Tooltip>
      <Dialog open={aberto} onClose={() => setAberto(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{`Mensagem no celular de ${usuario.name}`}</DialogTitle>
        <DialogContent>
          <TextField autoFocus fullWidth multiline minRows={4} variant="outlined" label="Mensagem" value={texto}
            onChange={(e) => setTexto(e.target.value)} helperText="Vai pelo WhatsApp da central para o celular cadastrado do usuário, com o seu nome." />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAberto(false)}>Cancelar</Button>
          <Button color="primary" variant="contained" disabled={enviando || texto.trim().length < 2} onClick={enviar}>Enviar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default MensagemCelular;
